import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';

export const Modal = ({ children, title, onClose, visible = false }) => (
    <>
        <div className={classNames(styles.modal, { [styles.visible]: visible })}>
            {title && <div className={styles.title}>{title}</div>}
            <div>{children}</div>
        </div>
        <div className={classNames(styles.overlay, { [styles.visible]: visible })} onClick={onClose} />
    </>
);

Modal.propTypes = {
    title: PropTypes.string,
    children: PropTypes.any,
    visible: PropTypes.bool,
    onClose: PropTypes.func,
};
